<template>
    <section id="keep-reading" class="px-[1.5rem] py-[2rem] md:py-[4rem] lg:pr-[2.142857rem] lg:pl-0">
        <div class="font-semibold mb-6 border-b-[0.0714285714rem] border-gray-300 pb-[1.0714285714rem]">
            <Heading :level="5" size="xl" color="text-ash-200">
            {{ title || 'Keep Reading' }}
            </Heading>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <NuxtLink v-for="(tagval, index) in tags" 
                :key="index" 
                :to="`${URL_CONFIG?.TAKE_5_DAILY}?t=${tagval?.tag}`" 
                external
                :id="`kr-tag-${index}`" 
                :title="`Keep reading about ${tagval?.tag}`" 
                :aria-label="`Keep reading about ${tagval?.tag}`"
            >
                <div
                    class="flex items-center px-[1.43rem] h-[3.57rem] bg-gray-300 rounded-[0.86rem] text-gray-900 transition-shadow duration-250 hover:shadow-[0.36rem_0.36rem_1.14rem_-0.43rem_-gray-600]">
                    <Icon icon="hashtag" class="text-pink-600 mr-[1.43rem]" />
                    {{ tagval?.tag }}
                </div>
            </NuxtLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import Icon from '../atom/icon.vue'
import Heading from '../atom/heading.vue'
import { URL_CONFIG } from '~~/shared/utils/url.const'

interface TagItem {
    tag: string
}

defineProps<{
    title?: string
    tags: TagItem[]
}>()
</script>
